import { Yup } from "components/DynamicForm/utils";
import { JSON_TABLE_INPUT_TYPE } from "utils/Constants";

const form = {
    sections: [{
        fields: [
            [
                {
                    "type": "text",
                    "name": "secuencia",
                    "disabled": true,
                    "label": "Secuencia",
                    "sizing": {
                        "sm": 4
                    }
                },
                {
                    "type": "text",
                    "name": "name",
                    "validation": Yup.string().required(),
                    "label": "Nombre Costo"
                },
            ],
            [
                {
                    "type": "checkbox",
                    "name": "isAllInclusive",
                    "label": "El precio es Todo Incluido",
                    "description": "Si un precio es todo incluido el costo del envio cubre el costo de los impuestos",
                }
            ],
            [
                {
                    "type": "checkbox",
                    "name": "isPublic",
                    "label": "Es precio al Publico",
                    "description": "El precio al publico esta disponible como una opcion en la calculadora de costo de un paquete",
                }
            ],
            [
                {
                    "type": "checkbox",
                    "name": "isDefault",
                    "label": "Es precio por Defecto",
                    "description": "Indica y el precio es el precio por Defecto",
                }
            ],
            [
                {
                    "type": "checkbox",
                    "name": "isActive",
                    "label": "Es precio Activo",
                    "description": "Indica si el precio esta activo o no",
                },
            ],
            [
                {
                    "type": JSON_TABLE_INPUT_TYPE,
                    "validation": Yup.string().required("REQUIRED_JSON_TABLE_ERROR"),
                    "dataSchema": {
                        "weight": {
                            "label": "Peso Kg",
                            "type": "number",
                            "isDecimal": true,
                            "step": ".5",
                            "min": "0",
                            "headingWidth": "col-6",
                        },
                        "price": {
                            "label": "Precio",
                            "type": "money",
                            "isDecimal": true,
                            "placeholder": "0,00",
                            "step": ".01",
                            "headingWidth": "col-6",
                        }
                    },
                    "sizing": {
                        "sm": {
                            "size": 6,
                            "offset": 3
                        }
                    },
                    "name": "priceTable",
                    "legend": "Tabla de Precio por Peso",
                    "defaultValue": [
                        {
                            "weight": "0.5",
                            "price": "0"
                        },
                        {
                            "weight": "1",
                            "price": "0"
                        },
                        {
                            "weight": "1.5",
                            "price": "0"
                        },
                        {
                            "weight": "2",
                            "price": "0"
                        },
                        {
                            "weight": "2.5",
                            "price": "0"
                        },
                        {
                            "weight": "3",
                            "price": "0"
                        },
                        {
                            "weight": "3.5",
                            "price": "0"
                        },
                        {
                            "weight": "4",
                            "price": "0"
                        },
                        {
                            "weight": "4.5",
                            "price": "0"
                        },
                        {
                            "weight": "5",
                            "price": "0"
                        },
                        {
                            "weight": "5.5",
                            "price": "0"
                        },
                        {
                            "weight": "6",
                            "price": "0"
                        },
                        {
                            "weight": "6.5",
                            "price": "0"
                        },
                        {
                            "weight": "7",
                            "price": "0"
                        },
                        {
                            "weight": "7.5",
                            "price": "0"
                        },
                        {
                            "weight": "8",
                            "price": "0"
                        },
                        {
                            "weight": "8.5",
                            "price": "0"
                        },
                        {
                            "weight": "9",
                            "price": "0"
                        },
                        {
                            "weight": "9.5",
                            "price": "0"
                        },
                        {
                            "weight": "10",
                            "price": "0"
                        },
                        {
                            "weight": "10.5",
                            "price": "0"
                        },
                        {
                            "weight": "11",
                            "price": "0"
                        },
                        {
                            "weight": "11.5",
                            "price": "0"
                        },
                        {
                            "weight": "12",
                            "price": "0"
                        },
                        {
                            "weight": "12.5",
                            "price": "0"
                        },
                        {
                            "weight": "13",
                            "price": "0"
                        },
                        {
                            "weight": "13.5",
                            "price": "0"
                        },
                        {
                            "weight": "14",
                            "price": "0"
                        },
                        {
                            "weight": "14.5",
                            "price": "0"
                        },
                        {
                            "weight": "15",
                            "price": "0"
                        },
                        {
                            "weight": "15.5",
                            "price": "0"
                        },
                        {
                            "weight": "16",
                            "price": "0"
                        },
                        {
                            "weight": "16.5",
                            "price": "0"
                        },
                        {
                            "weight": "17",
                            "price": "0"
                        },
                        {
                            "weight": "17.5",
                            "price": "0"
                        },
                        {
                            "weight": "18",
                            "price": "0"
                        },
                        {
                            "weight": "18.5",
                            "price": "0"
                        },
                        {
                            "weight": "19",
                            "price": "0"
                        },
                        {
                            "weight": "19.5",
                            "price": "0"
                        },
                        {
                            "weight": "20",
                            "price": "0"
                        },
                    ]
                },
            ],
        ]
    }]
};


export default form;